import { Route } from 'src/routes/_rootLayout/finance/deposits';

type UseApplyDueDateFilterArgsType = {
  dueDateFrom: string | null;
  dueDateTo: string | null;
};

type UseApplyDueDateFilterReturnType = {
  handleApplyDueDateFilter: (payload: UseApplyDueDateFilterArgsType) => void;
};

export const useApplyDueDateFilter = (): UseApplyDueDateFilterReturnType => {
  const navigate = Route.useNavigate();

  const handleApplyDueDateFilter = ({
    dueDateFrom,
    dueDateTo,
  }: UseApplyDueDateFilterArgsType) => {
    navigate({
      search: (prev) => ({
        ...prev,
        dueDateFrom: dueDateFrom ?? undefined,
        dueDateTo: dueDateTo ?? undefined,
        page: 1,
      }),
    });
  };

  return { handleApplyDueDateFilter };
};
